import { useClientSideTranslation } from 'src/services/i18n'
import { useGetCurrentLanguage } from 'src/store/game'
import { getOrdinalSuffix } from 'src/utils/getOrdinalSuffix'

export const useMarblePositionLabel = (position: number): string => {
  const { t } = useClientSideTranslation(useGetCurrentLanguage())

  switch (position) {
    case 1:
      return t('1st')
    case 2:
      return t('2nd')
    case 3:
      return t('3rd')
    default: // Fallback, but should never occur because we only have the first 3 positions
      return `${position}${getOrdinalSuffix(position)}`
  }
}
